module.exports = __webpack_public_path__ + "img/medium.9e6c7dfb.svg";